import { render } from "./GraphLegend.vue?vue&type=template&id=28824e54&ts=true"
import script from "./GraphLegend.vue?vue&type=script&lang=ts"
export * from "./GraphLegend.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../build_modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__